import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../Button';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import s from './StackOverlay.scss';
var StackOverlay = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, url = _a.url, onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
        React.createElement("div", { className: classnames(s['root'], className), style: { width: width, height: height } },
            React.createElement(Button, { className: s['button'], view: "b14", fullWidth: false, height: "medium", href: url, onClick: onClick, isFakeButton: !url && !onClick }, t('deviationview.overlay.stack.button')))));
};
StackOverlay.displayName = 'StackOverlay';
export default StackOverlay;
//# sourceMappingURL=StackOverlay.js.map